import React from 'react';
import { useTranslation } from 'react-i18next';
import ClockIcon from '../../icons/clock.svg';
import { ResultPageLayout } from '../../layouts/ResultPageLayout';
import { ReturnToBookingPortal } from './buttons';
import { RequestSubmittedProps } from './types';

export const RequestSubmitted = ({ guests, date, time, restaurantName, linkTo }: RequestSubmittedProps) => {
	const { t } = useTranslation();

	return (
		<ResultPageLayout headerIcon={ClockIcon} iconAltText={t('titles.request_submitted')}>
			<ResultPageLayout.Title>{t('titles.request_submitted')}</ResultPageLayout.Title>

			<ResultPageLayout.Body>
				<p>
					{t('messages.booking_request_submitted', {
						guests,
						plural: guests > 1 ? 's' : '',
						date,
						time
					})}
				</p>
				<p>
					{t('messages.restaurant_team_contact', { restaurantName })}
				</p>
			</ResultPageLayout.Body>

			<ResultPageLayout.Footer>
				<ReturnToBookingPortal to={linkTo} />
			</ResultPageLayout.Footer>
		</ResultPageLayout>
	);
};